import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import SelfReadingDocsSection from 'features/selfReadings/sections/SelfReadingDocsSection';

type Props = {}

const SelfReadingDocs = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");

  return (
    <>
      <Header title={t("selfReadingDocs.title")} includeBreadcrumbs />
      <ModuleContent>
        <SelfReadingDocsSection />
      </ModuleContent>
    </>
  )
}

export default SelfReadingDocs;